import AlWalletEditorController from './controller';
import templateUrl from './component.tpl.html';

angular.module('festzelt-os.modules.wallets.templates')
    .component(
        'alWalletTemplateEditor',
        {
            controller: AlWalletEditorController,
            controllerAs: 'vm',
            templateUrl,
            bindings: {
                walletTemplateId: '<',
                cancelTrigger: '=',
                onSaveSuccess: '&',
                onCancel: '&'
            }
        }
    );



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/components/al-wallet-template-editor/component.js